import React from 'react';
import './App.css';
import Header from './components/Header';
import Hero from './components/Hero';
import About from './components/About';
import Services from './components/Services';
import Customers from './components/Customers';
import Contact from './components/Contact';
import Footer from './components/Footer';

function App() {
  return (
    <div className="App min-h-screen bg-white">
      <Header />
      <Hero />
      <About />
      <Services />
      <Customers />
      <Contact />
      <Footer />
    </div>
  );
}

export default App;
